'use strict';
/*
 * Event Service.
 */

/**
 * REST CLIENT PER WS ENUMERAZIONI DATEX2
 */
module.exports = ['$rootScope', '$resource', function ($rootScope, $resource) {

        //var mainConfig=$rootScope.configs.ngDroAstralSituationRecordMainConfig;
        var mainConfig = global.ngDroAstralSituationRecordMainConfig;
        var baseEndPointUrl = mainConfig.PublicApiUrl;
        var datex2EnumsEndPointUrl = baseEndPointUrl + '';

        return $resource(baseEndPointUrl, {},
                {
                    'getDatex2Enums': {
                        method: 'GET',
                        //withCredentials: true,
                        url: datex2EnumsEndPointUrl + 'datex-enums'
                    }});
    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/datex2EnumsService.js
// module id = 254
// module chunks = 0